import { PostMessageBridge } from './PostMessageBridge'
import {
  OutboundEventType,
  type AutobetStartedPayload,
  type AutobetStoppedPayload,
  type BalanceChangedPayload,
  type BalanceInsufficientPayload,
  type BetPlacedPayload,
  type BetRejectedPayload,
  type BetResultPayload,
  type CashoutCompletedPayload,
  type GameErrorPayload,
  type GameLoadedPayload,
  type GameReadyPayload,
  type PlayerIdlePayload,
  type RoundBettingClosedPayload,
  type RoundBettingOpenPayload,
  type RoundEndedPayload,
  type RoundStartedPayload
} from './types'

function emit<T>(type: string, payload: T): void {
  PostMessageBridge.getInstance().send(type, payload)
}

// ── Lifecycle ──

export function emitGameLoaded(payload: GameLoadedPayload): void {
  emit(OutboundEventType.GAME_LOADED, payload)
}

export function emitGameReady(payload: GameReadyPayload): void {
  emit(OutboundEventType.GAME_READY, payload)
}

export function emitGameError(payload: GameErrorPayload): void {
  emit(OutboundEventType.GAME_ERROR, payload)
}

// ── Round lifecycle ──

export function emitRoundBettingOpen(payload: RoundBettingOpenPayload): void {
  emit(OutboundEventType.ROUND_BETTING_OPEN, payload)
}

export function emitRoundBettingClosed(payload: RoundBettingClosedPayload): void {
  emit(OutboundEventType.ROUND_BETTING_CLOSED, payload)
}

export function emitRoundStarted(payload: RoundStartedPayload): void {
  emit(OutboundEventType.ROUND_STARTED, payload)
}

export function emitRoundEnded(payload: RoundEndedPayload): void {
  emit(OutboundEventType.ROUND_ENDED, payload)
}

// ── Bets ──

export function emitBetPlaced(payload: BetPlacedPayload): void {
  emit(OutboundEventType.BET_PLACED, payload)
}

export function emitBetRejected(payload: BetRejectedPayload): void {
  emit(OutboundEventType.BET_REJECTED, payload)
}

export function emitBetResult(payload: BetResultPayload): void {
  emit(OutboundEventType.BET_RESULT, payload)
}

// ── Balance ──

export function emitBalanceChanged(payload: BalanceChangedPayload): void {
  emit(OutboundEventType.BALANCE_CHANGED, payload)
}

export function emitBalanceInsufficient(payload: BalanceInsufficientPayload): void {
  emit(OutboundEventType.BALANCE_INSUFFICIENT, payload)
}

// ── Cashout ──

export function emitCashoutCompleted(payload: CashoutCompletedPayload): void {
  emit(OutboundEventType.CASHOUT_COMPLETED, payload)
}

// ── Auto-bet ──

export function emitAutobetStarted(payload: AutobetStartedPayload): void {
  emit(OutboundEventType.AUTOBET_STARTED, payload)
}

export function emitAutobetStopped(payload: AutobetStoppedPayload): void {
  emit(OutboundEventType.AUTOBET_STOPPED, payload)
}

// ── Session ──

export function emitSessionExpired(): void {
  emit(OutboundEventType.SESSION_EXPIRED, {})
}

// ── Idle ──

export function emitPlayerIdleWarning(payload: PlayerIdlePayload): void {
  emit(OutboundEventType.PLAYER_IDLE_WARNING, payload)
}

export function emitPlayerIdlePaused(payload: PlayerIdlePayload): void {
  emit(OutboundEventType.PLAYER_IDLE_PAUSED, payload)
}
